import { render } from "./BlckProgress.vue?vue&type=template&id=3b811d50"
import script from "./BlckProgress.vue?vue&type=script&lang=js"
export * from "./BlckProgress.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__